import { createContext, useContext } from 'react';
import type { DlPanel } from '../../../../components/immobilien/dienstleisterWidgets';
import type { NachweisZeile, VertragsInfo } from '../../../../lib/dienstleister/detail';
import type { DlBereich, DlDetailDaten } from '../../../../lib/dienstleister/useDienstleisterDetail';

/** Abgeleitete Werte der Dienstleister-Detailseite – einmal berechnet, von Widgets und Panels gelesen. */
export interface DlSeitenWert {
  daten: DlDetailDaten;
  fehler: Partial<Record<DlBereich, string>>;
  name: string;
  email: string;
  telefon: string;
  notdienst: string;
  heute: string;
  vertretung: boolean;
  nachweise: NachweisZeile[];
  vertrag: VertragsInfo;
  /** Ticket-Regeln der eigenen Gewerke */
  regeln: DlDetailDaten['regeln'];
  ki: string;
  oeffnePanel: (key: DlPanel) => void;
  neuLaden: () => void;
  /** Formulare mit ungespeicherten Änderungen melden hier ihre Rückfrage an (null = abmelden). */
  registriereVerlassen: (rueckfrage: (() => void) | null) => void;
  schliessePanel: () => void;
  zumObjekt: (objektId: string) => void;
}

export const DlSeitenKontext = createContext<DlSeitenWert | null>(null);

export function useDlSeite(): DlSeitenWert {
  const w = useContext(DlSeitenKontext);
  if (!w) throw new Error('useDlSeite außerhalb der Dienstleister-Detailseite');
  return w;
}
